import { useState } from 'react';
import { Link } from 'react-router-dom';
import { buscarExpedientes } from '../servicios/consultas';
import { urlCarpetaDrive } from '../servicios/drive';
import { Badge, Encabezado, useNombresUsuarios } from '../componentes/Comunes';
import { mensajeError } from '../util';
import type { Expediente } from '@cji/shared';

export function BuscarExpediente() {
  const [radicado, setRadicado] = useState('');
  const [talonario, setTalonario] = useState('');
  const [res, setRes] = useState<Expediente[]>([]);
  const [buscado, setBuscado] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const nombre = useNombresUsuarios();

  async function buscar(e: React.FormEvent) {
    e.preventDefault();
    setCargando(true);
    setError('');
    try {
      setRes(await buscarExpedientes(radicado, talonario));
      setBuscado(true);
    } catch (err) {
      setError(mensajeError(err));
    } finally {
      setCargando(false);
    }
  }

  function renderDrive(exp: Expediente) {
    // Enlace directo a la carpeta en Drive (si tiene ID guardado).
    return (
      <a className="btn btn-drive btn-sm" href={urlCarpetaDrive(exp)}
         target="_blank" rel="noopener noreferrer">
        <i className="bx bxl-google" /> Abrir en Drive
      </a>
    );
  }

  return (
    <main className="pagina">
      <Encabezado icono="bx-search" titulo="Buscar Expediente" />

      <div className="tarjeta">
        <div className="tarjeta-titulo"><i className="bx bx-search-alt" /> Buscar Expedientes</div>
        <form onSubmit={buscar}>
          <div className="grid-2">
            <div className="campo">
              <label><i className="bx bx-file" /> Radicado Carpeta</label>
              <input placeholder="Ingrese radicado" value={radicado} onChange={(e) => setRadicado(e.target.value)} />
            </div>
            <div className="campo">
              <label><i className="bx bx-receipt" /> Talonario</label>
              <input placeholder="Ingrese talonario" value={talonario} onChange={(e) => setTalonario(e.target.value)} />
            </div>
          </div>
          <button className="btn btn-primario" disabled={cargando}><i className="bx bx-search" /> Buscar</button>
        </form>
      </div>

      {error && <div className="aviso error">{error}</div>}

      {res.length > 0 ? (
        <table className="table_av">
          <thead>
            <tr><th>Radicado</th><th>Talonario</th><th>Oficina</th><th>Préstamo</th><th>Responsable Actual</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {res.map((x) => (
              <tr key={x.id}>
                <td data-label="Radicado"><strong>{x.radicado}</strong></td>
                <td data-label="Talonario">{x.talonario || '—'}</td>
                <td data-label="Oficina">{x.oficinaId || '—'}</td>
                <td data-label="Préstamo">{nombre(x.custodiaActualEmail)}</td>
                <td data-label="Responsable">{nombre(x.responsableEmail)}</td>
                <td data-label="Acciones">
                  <div className="fila" style={{ gap: 8 }}>
                    <Link className="btn btn-primario btn-sm" to={`/expediente/${x.id}`}><i className="bx bx-show" /> Ver</Link>
                    {renderDrive(x)}
                    <Badge estado={x.estado} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="vacio">
          <i className={`bx ${buscado && !cargando ? 'bx-search-alt' : 'bx-search-alt-2'} icono`} />
          <h3 style={{ color: buscado ? '#6c757d' : 'var(--cji-green-dark)', margin: '0 0 8px', fontSize: 22 }}>
            {buscado && !cargando ? 'No se encontraron resultados' : 'Ingresa los criterios de búsqueda'}
          </h3>
          <p style={{ margin: 0 }}>Utiliza el radicado o talonario para buscar expedientes</p>
        </div>
      )}
    </main>
  );
}
